import {observer} from "mobx-react";
import classNames from "classnames";
import {useBetsImpression} from "../../../infrastructure/hooks/useBetsImpression";

export const OptionRate = observer(({children, controller, className, betsImpressionParams}) => {
  const ref = useBetsImpression(controller, betsImpressionParams);

  return (
    <bdi className={classNames(className)} ref={ref}>
      {children}
    </bdi>
  )
});
